<div class="theme-container">
<mat-chip-list *ngIf="appService.Data.compareList.length == 0">
    <mat-chip color="warn" selected="true">YOU HAVE NO ITEMS TO COMPARE.</mat-chip>
</mat-chip-list>

<mat-card *ngIf="appService.Data.compareList?.length > 0" class="p-0">

  <div class="mat-table compare-table">
    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.product' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <button mat-icon-button color="accent" class="remove" (click)="remove(product)"><mat-icon>close</mat-icon></button>
        <img [src]="product.images[0].small" alt="">
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.unitPrice' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <a [routerLink]="['/products', product.id, product.name]" class="product-name">{{product.name}}</a>
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.Price' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <b class="new-price">${{product.clientPrice | number : '1.2-2'}}</b>
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.Availibility' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
          <b class="text-muted">{{ (product.availibilityCount > 0) ? 'In stock':'Unavailable'}}</b>
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.ratings' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <app-rating [ratingsCount]="product.ratingsCount" [ratingsValue]="product.ratingsValue"></app-rating>
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.description' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <span class="text-muted lh">{{product.description}}</span>
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.Color' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <button mat-raised-button *ngFor="let color of product.color" [style.background]="color" class="color">&nbsp;</button>              
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.Size' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <span *ngFor="let size of product.size" class="size">{{size}}</span>
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        {{ 'TOBA LIGHT.label.Product.weight' | translate }}
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <span *ngIf="product.weight">{{product.weight}} g</span>
      </div>
    </div>

    <div class="mat-row">
      <div class="mat-cell">
        <button mat-raised-button color="warn" (click)="clear()">{{ 'TOBA LIGHT.label.clearAll' | translate }}</button>
      </div>
      <div class="mat-cell" *ngFor="let product of appService.Data.compareList">
        <button mat-raised-button color="primary" class="add" (click)="addToCart(product)">
          <mat-icon>shopping_cart</mat-icon>{{ 'TOBA LIGHT.label.addToCart' | translate }}</button>
      </div>
    </div>

  </div>
  
</mat-card>
</div>
